// Simple substring + token-prefix search with a tiny relevance score.
// Adequate for ~25 entries; no need for a fuzzy lib.

import type { SlideType } from '../data/slideTypeCatalog'

export function searchSlides(catalog: SlideType[], query: string): SlideType[] {
  const q = query.trim().toLowerCase()
  if (!q) return catalog

  const tokens = q.split(/\s+/).filter(Boolean)

  const scored = catalog
    .map((slide) => {
      const haystack = `${slide.name} ${slide.desc} ${slide.sectionLabel} ${slide.categories.join(' ')}`.toLowerCase()
      let score = 0
      for (const token of tokens) {
        if (slide.name.toLowerCase().startsWith(token)) score += 4
        else if (slide.name.toLowerCase().includes(token)) score += 3
        else if (haystack.includes(token)) score += 1
        else return null
      }
      return { slide, score }
    })
    .filter((x): x is { slide: SlideType; score: number } => x !== null)
    .sort((a, b) => b.score - a.score)

  return scored.map((x) => x.slide)
}
